import { LandingImage } from "@/blocks/Landing/LandingImage";

export default function LandingImageWrapper(props: any) {
  const { id, heading, image } = props;

  return (
    <div className='hero w-full relative overflow-hidden full-width-div' id={id}>
      <LandingImage heading={heading}
        image={(image + '?fit=fill&f=center') || 'https://placehold.co/1440x962'}></LandingImage>
    </div>
  );
}